export default __webpack_public_path__ + "static/media/HUD-Effects-Ice Buildup.ceac3321.jpg";